function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_587",
  "data-name": "Group 587",
  transform: "translate(-437 -298)"
}, React.createElement("rect", {
  id: "Rectangle_415",
  "data-name": "Rectangle 415",
  width: 30,
  height: 20,
  rx: 3,
  transform: "translate(437 298)",
  fill: "#09b0ee"
}), React.createElement("text", {
  id: "abc",
  transform: "translate(442 312)",
  fill: "#fff",
  fontSize: 12,
  fontFamily: "Roboto-Regular, Roboto"
}, React.createElement("tspan", {
  x: 0,
  y: 0
}, "abc")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/abc.9fb76709.svg";
export { SvgComponent as ReactComponent };